export default "__VITE_ASSET__fuX7Q9ds__"